/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable no-use-before-define */
import React, {
  useEffect, useState, forwardRef, useImperativeHandle,
} from 'react';
import { fireResizeMessage } from '../global/ap-resize';
import Portal from './portal';
import './_modal.scss';

const Modal = forwardRef((props, ref) => {
  const [display, setDisplay] = useState(false);
  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        handleClose();
        document.body.classList.remove('modal-open');
      }
    };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, []);

  useImperativeHandle(
    ref,
    () => ({
      openModal: () => handleOpen(),
      closeModal: () => handleClose(),
      display,
    }),
  );

  const handleOpen = () => {
    fireResizeMessage(true);
    setTimeout(() => {
      document.body.classList.toggle('modal-open');
    }, 100);
    setDisplay(true);
  };

  const handleClose = () => {
    document.body.classList.toggle('modal-open');
    setTimeout(() => {
      const navBar = document.querySelector('.navbar');
      if (navBar) {
        navBar.style.paddingTop = '0';
      }
      setTimeout(() => {
        if (navBar) {
          navBar.style.paddingTop = '2px';
        }
      }, 500);
      setDisplay(false);
    }, 500);
  };

  if (display) {
    return (
      <Portal>
        <div className="modal">
          {props.children}
        </div>
      </Portal>
    );
  }

  return null;
});

export default Modal;
